import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button/Button";
import ReactPlayer from "react-player";
import { useVideoApp } from "hooks/videoApp/useVideApp";
import { Box } from "@mui/material";

export const ModalVideoApp = () => {
  const { openModalApp, setModalApp } = useVideoApp();
  const closeModal = () => {
    setModalApp(false);
  };

  return (
    <Dialog
      open={openModalApp}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      scroll="paper"
    >
      <DialogTitle className="text-center text-2xl font-bold text-gray-900">
        TE INVITAMOS A CONOCER NUESTRA APLICACIÓN MÓVIL.
      </DialogTitle>
      <DialogContent>
        <Box className="w-full flex justify-center items-center">
          <iframe
            width="1300"
            height="600"
            src="https://www.youtube.com/embed/BWYXkC0iLEU"
            title="TE INVITAMOS A CONOCER NUESTRA APLICACIÓN MÓVIL"
            allow=" TE INVITAMOS A CONOCER NUESTRA APLICACIÓN MÓVIL"
          ></iframe>
        </Box>
      </DialogContent>
      <DialogActions>
        <div className="flex justify-content-center gap-4 align-center">
          <Button
            variant="contained"
            color="error"
            onClick={() => closeModal()}
          >
            Cerrar
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
